export const RequestStatus = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export const DEFAULTS = {
  BOUNDS: {
    _sdkType: 'LatLngBounds',
    ne: {
      _sdkType: 'LatLng',
      lat: 54.4148886,
      lng: -83.35960175,
    },
    sw: {
      _sdkType: 'LatLng',
      lat: -0.85726051,
      lng: -113.39867847,
    },
  },
};


export const PayoutMethod = Object.freeze({
  PAYPAL: 'paypal',
  STRIPE: 'stripe',
});

export const StatusCode = Object.freeze({
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
});